import Api from '@/services/Api'

export default {
  // Método que llama a la url para crear un chat
   getGuiasProessat () {
     return Api().get("/guias-proessat");
  },
  // Método que llama a la url para crear un chat
  getGuiasProessatByCompany (params) {
    return Api().get("/guias-proessat-by-company/"+params);
  },
  updateGuiaProessat (params) {
    return Api().put("/guias-proessat",params);
  },
  addGuiaProessat (params) {
    return Api().post("/guias-proessat",params);
  },
  getGuiaProessat (params) {
    return Api().get("/guia-proessat/"+params);
  },
  deleteGuiasProessat (params) {
    return Api().delete("/guias-proessat/"+params);
  },
  getGuiasProessatDataByGuiaProessat (params) {
    return Api().get("/guia-proessat-data-by-guia-proessat/"+params);
  },
  updateGuiaProessatData (params) {
    return Api().put("/guia-proessat-data",params);
  },
  addGuiaProessatData (params) {
    return Api().post("/guia-proessat-data",params);
  },
  getGuiaProessatData (params) {
    return Api().get("/guia-proessat-data/"+params);
  },
  deleteGuiaProessatDataByGuiaProessat (params) {
    return Api().delete("/guia-proessat-data-by-guia-proessat/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/GuiaProessatService.js